export class CustomerIdentity{
    public identityTypeId! : any;
    public value! : string;
    public countryCode! : string;
    public region! : string;
}